import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, defineAsyncComponent, watch } from 'vue'
import { storeToRefs } from 'pinia'
import DropdownFilters from '../components/DropdownFilters.vue'
import { useStationStore } from '@/pinia-store/useStationStore'
import { useSpecialtyStore } from '@/pinia-store/useSpecialtyStore'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'SpecialtyFilter',
  setup(__props) {

const specialtyIcon = defineAsyncComponent(() => import('@/assets/icons/doctor.vue'))
const stationStore = useStationStore()
const specialtyStore = useSpecialtyStore()
const companyStore = useCompanyStore()
const { listStationsQuery, listStations } = storeToRefs(stationStore)

const companyIds = computed<number[]>(() => {
  const fromGrid = [
    ...new Set((listStations.value?.data ?? []).map((company) => company.companyId))
  ]
  return fromGrid.length ? fromGrid : companyStore.myCompanies.map((company) => company.id)
})

watch(companyIds, (ids) => ids.forEach((id) => void specialtyStore.fetchOptions(id)), {
  immediate: true
})

const items = computed(() => {
  const official = new Map<number, string>()
  const company: { title: string; value: string; subtitle?: string }[] = []
  companyIds.value.forEach((companyId) => {
    const options = specialtyStore.optionsOf(companyId)
    options?.official.forEach((o) => official.set(o.id, o.name))
    options?.company.forEach((o) =>
      company.push({ title: o.name, value: `c:${o.id}`, subtitle: 'Da empresa' })
    )
  })
  return [
    { title: 'Sem especialidade', value: 'none' },
    ...[...official.entries()].map(([id, name]) => ({
      title: name,
      value: `o:${id}`,
      subtitle: 'Oficial (CFM)'
    })),
    ...company
  ]
})

const selected = computed(() => [
  ...(listStationsQuery.value.specialtyIds ?? []).map((id) => `o:${id}`),
  ...(listStationsQuery.value.companySpecialtyIds ?? []).map((id) => `c:${id}`),
  ...(listStationsQuery.value.withoutSpecialty ? ['none'] : [])
])

function toggleIn(list: string[] | undefined, id: string): string[] {
  const set = new Set(list ?? [])
  if (set.has(id)) set.delete(id)
  else set.add(id)
  return [...set]
}

async function toggle(item: { value: string }): Promise<void> {
  const query = listStationsQuery.value
  const [kind, id] = item.value.split(':')
  await stationStore.setSpecialtyFilter({
    specialtyIds: kind === 'o' ? toggleIn(query.specialtyIds, id) : [...(query.specialtyIds ?? [])],
    companySpecialtyIds:
      kind === 'c'
        ? toggleIn(query.companySpecialtyIds, id)
        : [...(query.companySpecialtyIds ?? [])],
    withoutSpecialty: item.value === 'none' ? !query.withoutSpecialty : !!query.withoutSpecialty
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DropdownFilters, {
    title: "Especialidade",
    badge: "NOVO",
    items: items.value,
    icon: _unref(specialtyIcon),
    multiple: "",
    "selected-value": selected.value,
    onClicked: toggle
  }, null, 8, ["items", "icon", "selected-value"]))
}
}

})